import { useState } from 'react'
import { login, setupFirstAdmin, type ApiError, type Me } from './api'

/**
 * The sign-in screen. When the register has no users yet (`needsSetup`), it
 * becomes a one-time "create the first administrator" form instead.
 */
export function Login({
  needsSetup,
  onSignedIn,
}: {
  needsSetup: boolean
  onSignedIn: (me: Me) => void
}) {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [pw, setPw] = useState('')
  const [pw2, setPw2] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit() {
    setErr('')
    if (needsSetup) {
      if (pw.length < 10) return setErr('Use at least 10 characters.')
      if (pw !== pw2) return setErr('The two passwords do not match.')
    }
    setBusy(true)
    try {
      const me = needsSetup
        ? await setupFirstAdmin(email.trim().toLowerCase(), name.trim(), pw)
        : await login(email.trim().toLowerCase(), pw)
      onSignedIn(me)
    } catch (e) {
      setErr((e as ApiError).message ?? 'Could not sign in.')
      setBusy(false)
    }
  }

  return (
    <div className="center">
      <div className="loginbox">
        <div className="mark" style={{ marginBottom: 16 }}>
          A
        </div>
        <h2>{needsSetup ? 'Create the first administrator' : 'Access Register'}</h2>
        <p>
          {needsSetup
            ? 'No accounts exist yet. Set up the first administrator — you can add everyone else from inside the app.'
            : 'Sign in with your Analytix email and password.'}
        </p>

        <label htmlFor="lemail">Email</label>
        <input
          id="lemail"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && !needsSetup && submit()}
        />

        {needsSetup && (
          <>
            <label htmlFor="lname">Your name</label>
            <input id="lname" type="text" value={name} onChange={(e) => setName(e.target.value)} />
          </>
        )}

        <label htmlFor="lpw">Password</label>
        <input
          id="lpw"
          type="password"
          autoComplete={needsSetup ? 'new-password' : 'current-password'}
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && !needsSetup && submit()}
        />

        {needsSetup && (
          <>
            <label htmlFor="lpw2">Repeat password</label>
            <input
              id="lpw2"
              type="password"
              autoComplete="new-password"
              value={pw2}
              onChange={(e) => setPw2(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && submit()}
            />
          </>
        )}

        {err && <p className="req">{err}</p>}

        <button type="button" className="btn p" disabled={busy || !email || !pw} onClick={submit}>
          {busy ? 'Working…' : needsSetup ? 'Create administrator' : 'Sign in'}
        </button>
      </div>
    </div>
  )
}
